var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.52,
    height: 61.9,
    viewBox: "0 0 64.52 61.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "\\u0428\\u0430\\u0440 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.76,
    y: 37.76,
    width: 63,
    height: 23.37,
    rx: 4.9,
    ry: 4.9,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.52px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.19,
    cy: 28.59,
    r: 3.18,
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.21,16.33c6.97-9.71,23.47-9.12,29.95,0",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.72,21.47c4.18-5.82,14.05-5.46,17.94,0",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.76,10.58c9.55-13.3,32.12-12.49,41,0",
    style: {
      fill: "none",
      stroke: "#4d4d4d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.82px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(17.3 54.9)",
    style: {
      fill: "#4d4d4d",
      fontFamily: "ArialRoundedMTBold, &apos",
      fontSize: 15
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FREE"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.ad56bac9931a4c9375abc5846f1c29e3.svg";
export { ForwardRef as ReactComponent };